import { CURRENCY_CONFIGS } from './constants';
import { type CurrencyKey } from './types';

export function formatCurrency(value: number, currency: CurrencyKey): string {
  const { symbol } = CURRENCY_CONFIGS[currency];
  return `${symbol}${Math.abs(value).toLocaleString()}`;
}

export function formatCurrencyDecimal(value: number, currency: CurrencyKey): string {
  const { symbol } = CURRENCY_CONFIGS[currency];
  return `${symbol}${value.toFixed(2)}`;
}

export function formatNumber(value: number): string {
  return value.toLocaleString();
}

export function formatPercent(value: number): string {
  return `${value}%`;
}

export function getCurrencySymbol(currency: CurrencyKey): string {
  return CURRENCY_CONFIGS[currency].symbol;
}
